import React, { useEffect, useState } from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Typography,
  useTheme,
} from "@mui/material";
import StyledButton from "../../ui/buttons/StyledButton";
import LoadingBar from "../../ui/LoadingBar";

function CustomModal({
  showModal,
  title,
  body,
  onDismissTitle = "Return",
  onDismiss,
  onConfirmTitle = "Confirm",
  onConfirm = null,
  onDismissColour="primary",
  onConfirmColour="primary",
  timerLengthSeconds=null
}) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [componentRendered, setComponentRendered] = useState(false);
  const [time, setTime] = useState(0);
  const theme = useTheme();

  useEffect(() => {
    if (showModal && componentRendered) {
      // Show the dialog when waitToShowModal is complete
      setDialogOpen(true);
    } else {
      console.log("setComponentRendered");
      setComponentRendered(true);
    }
  }, [showModal]);

  const handlePreventClose = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    const start = Date.now();
    const interval = setInterval(() => {
      const elapsed = (Date.now() - start) / 1000; // seconds
      setTime(Math.min(elapsed, timerLengthSeconds)); // clamp to 30
    }, 100);
  
    return () => clearInterval(interval);
  }, [showModal])

  //if onConfirm is not supplied (is null) then show first set of dialogActions, otherwise show the second set (both buttons)
  const dialogActions = !onConfirm ? (
    <>
      <StyledButton
        onClick={() => {
          onDismiss();
          setDialogOpen(false);
        }}
        color={onDismissColour}
        variant="outlined"
        autoFocus
      >
        {onDismissTitle}
      </StyledButton>
    </>
  ) : (
    <Box
      sx={{ justifyContent: "space-between", display: "flex", width: "100%", p: 0.5 }}
    >
      <StyledButton
        onClick={() => {
          onDismiss();
          setDialogOpen(false);
        }}
        color={onDismissColour}
        variant="outlined"
        autoFocus
        disabled={timerLengthSeconds && time < timerLengthSeconds}
      >
        {onDismissTitle}
      </StyledButton>

      <StyledButton
        onClick={() => {
          onConfirm();
          setDialogOpen(false);
        }}
        color={onConfirmColour}
        variant="outlined"
        autoFocus
        disabled={timerLengthSeconds && time < timerLengthSeconds}
      >
          {onConfirmTitle}
      </StyledButton>
    </Box>
  );

  return (
    <>
      <Dialog
        open={dialogOpen}
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {body}
          </DialogContentText>
        </DialogContent>
        <DialogActions>{dialogActions}</DialogActions>
        
        {timerLengthSeconds ? <Box
          sx={{
            justifyContent: "flex-end",
            float: "right",
            flexDirection: "row",
            display: "flex",
            mt: -1,
            p: 2
          }}
        >
          <LoadingBar time={time} maxTime={timerLengthSeconds}/>
        </Box> : <></>}
        
      </Dialog>
    </>
  );
}

export default CustomModal;
